import { Loader2 } from 'lucide-react';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryParams } from '@/hooks/useQueryParams';
import { getTramite } from '@/services/tramiteService';
import { AUTH_ROUTES } from '../constants';
import { useAuth } from '../hooks/useAuth';

/**
 * AutoLogin component - Handles automatic login with query parameters
 */
const AutoLogin: React.FC = () => {
  const { isAuth, login, error } = useAuth();
  const query = useQueryParams();
  const navigate = useNavigate();
  const email = query.get('email');
  const password = query.get('password');
  const tramiteId = query.get('tramite_id');

  useEffect(() => {
    if (email && password) {
      login({ email, password });
    } else {
      navigate(AUTH_ROUTES.LOGIN);
    }
  }, [email, password, login, navigate]);

  useEffect(() => {
    if (isAuth) {
      if (tramiteId) {
        getTramite({ id: tramiteId })
          .then(tramite => navigate(AUTH_ROUTES.DASHBOARD, { state: { tramite } }))
          .catch(() => navigate(AUTH_ROUTES.LOGIN));
      } else {
        navigate(AUTH_ROUTES.LOGIN);
      }
    }
  }, [isAuth, tramiteId, navigate]);

  useEffect(() => {
    if (error) {
      navigate(AUTH_ROUTES.LOGIN);
    }
  }, [error, navigate]);

  return (
    <div className="flex min-h-screen min-w-full justify-center items-center">
      <Loader2 className="h-12 w-12 animate-spin text-blue-500" />
    </div>
  );
};

export default AutoLogin;